// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/**
 * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/*
* Ensure proper alignment of the vue material icons
*/
.material-design-icon[data-v-7bf21eca] {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
.app-navigation-caption[data-v-7bf21eca] {
  color: var(--color-text-maxcontrast);
  line-height: var(--default-clickable-area);
  white-space: nowrap;
  text-overflow: ellipsis;
  box-shadow: none !important;
  user-select: none;
  pointer-events: none;
  margin-inline-start: 12px;
  padding-inline-end: 14px;
  height: var(--default-clickable-area);
  display: flex;
  align-items: center;
}`, "",{"version":3,"sources":["webpack://./node_modules/@nextcloud/vue/dist/assets/NcActionCaption-BNDtcWJ7.css"],"names":[],"mappings":"AAAA;;;EAGE;AACF;;;EAGE;AACF;;CAEC;AACD;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,oCAAoC;EACpC,0CAA0C;EAC1C,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;EAC3B,iBAAiB;EACjB,oBAAoB;EACpB,yBAAyB;EACzB,wBAAwB;EACxB,qCAAqC;EACrC,aAAa;EACb,mBAAmB;AACrB","sourcesContent":["/**\n * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/**\n * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/*\n* Ensure proper alignment of the vue material icons\n*/\n.material-design-icon[data-v-7bf21eca] {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n.app-navigation-caption[data-v-7bf21eca] {\n  color: var(--color-text-maxcontrast);\n  line-height: var(--default-clickable-area);\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  box-shadow: none !important;\n  user-select: none;\n  pointer-events: none;\n  margin-inline-start: 12px;\n  padding-inline-end: 14px;\n  height: var(--default-clickable-area);\n  display: flex;\n  align-items: center;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
